// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"e19b0a60","886":"845e5e7d"}[chunkId] + ".chunk.css";
};